import { BlockLayoutSpec, StaticSize } from '../../types';
import { HTML_BLOCK_FALLBACK_HEIGHT } from '../../helpers/block-types/html';

// Static rather than calculated-height. An HTML block always has a definite
// height — either the one the embedded page reported over postMessage, or the
// fallback — so there is nothing to measure and nothing to wait for. Declaring
// it calculated-height would make the layout wait on a measurement that never
// arrives for artifacts that do not report.
export function createHtmlBlockLayout(
  width: StaticSize['width'],
  height: number | null
): BlockLayoutSpec {
  return {
    spec: {
      type: 'static',
      width,
      height: height ?? HTML_BLOCK_FALLBACK_HEIGHT,
    },
    verticalAlign: 'top',
  };
}
